import { animate, AnimationBuilder, style } from '@angular/animations';
import { ElementRef, Injectable } from '@angular/core';
import { Event, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { StorageService } from '@app/data/browser/storage.service';
import { GoogleAnalyticsService } from './google-analytics.service';

import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { IFingerPrint } from '@app/core/models/app.model';
declare var visitData;
@Injectable({ providedIn: 'root' })
export class UtilService {
  private el: ElementRef;

  constructor(
    private _animationBuilder: AnimationBuilder,
    private _router: Router,
    private _storageService: StorageService,
    private _gaServices: GoogleAnalyticsService
  ) {}

  private _sendMetric(
    category: string,
    action: string,
    label: string = null,
    extraData: any = null
  ) {
    const visitorId = this._getVisitor();
    const source = 'frontend';
    let customer_id = null;

    if (extraData && typeof extraData === 'object') {
      extraData = JSON.stringify(extraData);
    }
    if (extraData && typeof extraData === 'number') {
      extraData = extraData.toString();
    }

    const data = {
      customer_id,
      category,
      action,
      label,
      extra_data: extraData,
      source,
      visitor_id: visitorId,
    };
    // this._userSessionFacade.getCustomerId().subscribe((customerId) => {
    //   data.customer_id = customerId;
    //   this._http.put('/metrics/put_record/', data).subscribe();
    // });
  }

  private _getVisitor(): string {
    let visitorInfo = sessionStorage.getItem(CONST.PROP_STORAGE_VISITOR);
    if (!visitorInfo) {
      visitorInfo = this._getRandomString();
      sessionStorage.setItem(CONST.PROP_STORAGE_VISITOR, visitorInfo);
    }
    return visitorInfo;
  }

  private _getActualDate(): string {
    return new Date().toISOString();
  }

  public getISODate(): string {
    const date = this._getActualDate().slice(0, -5) + 'Z';
    return date;
  }

  private _getRandomString() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public setUserMetricInfo() {
    return {
      visitor_id: this._getVisitor(),
      date: this._getActualDate(),
      source: 'frontend',
    };
  }

  public initLoader(element: ElementRef) {
    this.el = element;
  }

  public hideSplash() {
    const player = this._animationBuilder
      .build([style({ opacity: '1' }), animate(800, style({ opacity: '0' }))])
      .create(this.el.nativeElement);

    player.onDone(() => {
      if (typeof this.el.nativeElement.remove === 'function') {
        this.el.nativeElement.remove();
      } else {
        this.el.nativeElement.style.display = 'none';
      }
    });

    setTimeout(() => player.play(), 300);
  }

  public navigateTo(url: string, params?: NavigationExtras) {
    this._router.navigate([url], params ?? {});
  }

  public changeDateToISOString(date: Date) {
    return date.toLocaleDateString('en-US');
  }

  public logoutUser() {
    this._storageService.removeItem(CONST.PROP_SESSION_TOKEN);
    this.navigateTo('');
  }

  public trackEvent(
    category: string,
    action: string,
    label: string = null,
    extraData: any = null,
    value: number = 0
  ) {
    this._gaServices.sendEvent(category, action, label, value);

    this._sendMetric(category, action, label, extraData);
  }

  public getFingerPrintData() {
    const { userAgent, platform } = window.navigator;
    const infoSystem = `${userAgent} / platform: ${platform}`;
    const height = document.body.clientHeight;
    const widht = document.body.clientWidth;
    const w: any = window;
    let internetConnectionType = 'not-defined';
    let origin;
    try {
      origin = visitData.get().source;
    } catch {
      origin = '(Direct)';
    }
    if (w.navigator.connection) {
      internetConnectionType = w.navigator.connection.effectiveType;
    }

    const fingerPrint = {
      origin: origin,
      info_system: infoSystem,
      screen_size: `${widht}x${height}`,
      internet_connection_type: internetConnectionType,
    } as IFingerPrint;
    return fingerPrint;
  }

  public getUrlByChangeEvent(): Observable<Event> {
    return this._router.events.pipe(filter((event) => event instanceof NavigationEnd));
  }

  public downloadFiles(url) {
    // window.open(url, '_blank', 'noopener noreferrer');
    var link = document.createElement('a');
    link.download = 'resumen';
    link.href = url;
    link.click();
  }

  public onOpenLink(url): Window | boolean {
    return url && typeof url === 'string'
      ? window.open(url, '_blank', 'noopener noreferrer')
      : false;
  }

  public redirectToUrl(url): Window | boolean {
    return url && typeof url === 'string'
      ? window.open(url, '_self', 'noopener noreferrer')
      : false;
  }

  public maskedValue(value: string | number, visibleDigits: number): string {
    typeof value === 'number' ? (value = String(value)) : value;
    const maskLength = Math.max(value.length - visibleDigits, 0);
    const maskedValue = 'X'.repeat(maskLength) + value.slice(maskLength);
    return maskedValue;
  }
}
